/**
 * EncounterSlice State Definition
 * 
 * Defines the state interface and initial state for the encounter slice.
 */

import { EncounterType } from '../types/encounterTypes';

/**
 * State interface for the encounter slice.
 * Follows the standard BaseSliceState pattern with encounter-specific naming.
 */
export interface EncounterSliceState {
  /** The current encounter being viewed/edited, or null if none selected */
  currentEncounter: EncounterType | null;
  /** Whether any edits have been made since loading/saving */
  isEdited: boolean;
  /** List of field names that have been modified */
  editedFields: string[];
  /** Validation errors keyed by field name */
  validationErrors: Record<string, string>;
}

/**
 * Initial state for the encounter slice.
 */
export const initialState: EncounterSliceState = {
  currentEncounter: null,
  isEdited: false,
  editedFields: [],
  validationErrors: {},
};
